import { AngularFirestore } from '@angular/fire/firestore';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OptionsAndLinksService {
  
  selectedOptions = [];
  list = [];
  mainPrice: number = 599;
  cart = [];
  totalPrice: number = 0;

  constructor(private db: AngularFirestore) { }

  removeFromCart(option: any){
    let newCart = [];
    if (this.cart.length > 0) {
      for (let x of this.cart) {
        if (option.optionCode != x.option.optionCode) {
          newCart.push(x);
        }
      }
      this.cart = newCart;
    }

    console.log(this.cart);
}

  calculateTotalPrice() : number{
    let cartValue = 0;
    if (this.cart.length < 1){
      console.log("huh");
      return this.mainPrice;
    } else {
      for (let x of this.cart){
        cartValue = cartValue + x.option.optionPrice;
      }
      return cartValue + this.mainPrice;
    }
  }

  addToCart(option: any, selectedPage: number){
    let newCart = [];
    if (this.cart.length > 0) {
      for (let x of this.cart) {
        if (selectedPage != x.page) {
          newCart.push(x);
        }
      }
      newCart.push({ page: selectedPage, option: option })
      this.cart = newCart;
    } else {
      this.cart.push({page: selectedPage, option: option})
    }

    console.log(this.cart);
  }

  isInCart(option: any){
    let length = 0;
    for  (let x of this.cart){
      if (option.optionCode == x.option.optionCode){
        length = length + 1;
      }
    }
    if (length > 0){
      return true;
    } else {
      return false;
    }
  }

  checkout(fielda: string, fieldb: string, email: string){
    let numberList = [];
    let sortedList = [];
    let stringForDb = "";
    for (let x of this.cart){
      numberList.push(x.option.optionCode);
    }
    sortedList =  numberList.sort((n1,n2) => n1 - n2);
    for (let x of sortedList){
      stringForDb = stringForDb + String(x);
    }

    this.db.collection('GR-checkoutLinks', ref => ref.where("codes", "==", stringForDb)).valueChanges()
    .subscribe( data => {
      // console.log(data[0]['link']);
      let link = data[0]['link'];
      let ref = this.db.collection('GR-checkoutData').ref.doc().id;
      if (email.length > 1){
        this.db.collection('GR-checkoutData').doc(ref).set({
          checkoutLink: link,
          field_a: fielda,
          field_b: fieldb,
          email: email,
          time: new Date()
        });
      }
      window.open(link,"_blank");
    })
  }

  hasBeenThere(selectedPage: number){
    let found: number = 0;
    for (let x of this.cart){
      if  (x.page == selectedPage){
        found = found + 1;
      } 
    }
    if (found > 0){
      return true;
    } else {
      return false;
    }
  }

  isInList(option: any){
    let length = 0;
    for  (let x in this.selectedOptions){
      if (this.selectedOptions[x].optionCode == option.optionCode){
        length = length + 1;
      }
    }
    if (length > 0){
      return true;
    } else {
      return false;
    }
  }

    // addToOptionList(option: any){
  //   this.list = [];
  //   console.log(this.isInList(option));


  //   if (this.isInList(option) == false){
  //     this.selectedOptions.push(option);
  //     this.totalPrice = this.totalPrice + option.optionPrice;
  //   } else {
  //     for (let x in this.selectedOptions){
  //       if (option.optionCode != this.selectedOptions[x].optionCode){
  //         this.list.push(this.selectedOptions[x]);
  //       } else {
  //         this.totalPrice = this.totalPrice - this.selectedOptions[x].optionPrice;
  //       }
  //     }
  //     this.selectedOptions = this.list;
  //   }
  //   console.log(this.selectedOptions);
  // }
}

